import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button, Input, AutoComplete } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../supplierDueSlice";
import { fetchSupplierDue } from "../supplierDueThunk";
import { getAccountBySeachApi } from "../../../../apiservice/setting";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";
import { useLocation, useSearchParams } from "react-router-dom";
import { fetchSuppliers } from "../../../../store/commonThunks/lookups";

const { Search } = Input;

const SupplierDueFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters, loading } = useSelector((state) => state.supplierDue);
  const lookups = useSelector((state) => state.lookups);
  const [accounts, setAccounts] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();


  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  useEffect(() => {
    dispatch(fetchSuppliers());
  }, [dispatch]);

  // Drill-down from Balance Sheet: /reports/creditors-balance/<toDate>?fromDate=<fromDate>
  useEffect(() => {
    const path = pathname.split("/")[3];
    if (path) {
      const fromDate = searchParams.get("fromDate") || null;
      const nextFilters = { ...filters, fromDate, toDate: path };
      dispatch(setFilters({ fromDate, toDate: path }));
      dispatch(fetchSupplierDue(nextFilters));
    }
  }, []);



  const handleSearch = async (value) => {
    if (!value.trim()) {
      setAccounts([]);
      return;
    }

    setSearchLoading(true);
    try {
      const res = await getAccountBySeachApi({
        query: value,
        type: "creditor",
      });
      setAccounts(res.data || []);
    } catch (err) {
      messageApi.error("Failed to search suppliers");
      console.error(err);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleReport = () => {
    if (filters.filterType === "Supplier Wise" && !filters.supplierId) {
      messageApi.warning("Please select a supplier");
      return;
    }

    dispatch(fetchSupplierDue(filters)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded successfully");
      } else {
        messageApi.error("Failed to fetch records");
      }
    });
  };

    const filterTypes = [
        { value: "All Supplier", label: "All Supplier", display_text: "All Supplier", },
        { value: "Supplier Wise", label: "Supplier Wise", display_text: "Supplier Wise", },
    ];

    return (
        <Card className="mb-4 shadow-md rounded-xl">
            <Row gutter={[16,16]} >
                <Col xs={24} sm={12} md={8} lg={6} xl={6} className="filter-item">
                    <label>Filter Type</label>
                    <SearchListAutoComplete
                        optionsList={filterTypes}
                        value={
                        filters.filterType
                            ? { value: filters.filterType, label: filters.filterType }
                            : null
                        }
                        onSelect={(obj) => handleFilterChange("filterType", obj?.value)}
                        placeholder="Filter Type"
                        style={{ width: "100%" }}
                        filterOption={(inputValue, option) =>
                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                        }
                        showAddNew={false}
                    />
                </Col>

        {filters.filterType === "Supplier Wise" && (
          <Col xs={24} sm={12} md={8} lg={6} xl={6} className="filter-item">
            <label>Search Supplier</label>
            <SearchListAutoComplete
              entityType="supplier"
              optionsList={lookups.suppliers.map((e) => ({
                sale_id: e.acc_id,
                display_text: e.acc_name,
              }))}
              onSelect={(obj) => handleFilterChange("supplierId", obj?.sale_id)}
              placeholder="Supplier"
              showAddNew={false}
            />
          </Col>
        )}

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
          }}
        />

        <Col xs={24} sm={12} md={8} lg={6} xl={6} className="filter-item" style={{ display: "flex", alignItems: "flex-end", height: 64 }}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            loading={loading}
            style={{height:35.19}}
            block
            data-testid="report-btn"
            
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default SupplierDueFilters;
